import { type Theme, tooltipClasses } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const TooltipPopperStyle: StyleExtend<Theme> = {
  inset: '0 !important',
  margin: 'auto !important',
  width: 'min(calc(100% - 2rem), 43rem)',
  height: 'fit-content',
  transform: 'translateY(10%) !important',
  position: 'fixed !important',

  [`&.${tooltipClasses.popper} .${tooltipClasses.tooltip}`]: {
    maxWidth: 'unset',
    margin: '0',
    padding: '1.5rem',
    backgroundColor: (theme) => theme.palette.customColors.white50,
    borderRadius: '1rem',
    boxShadow: (theme) => theme.customStyling.shadow.coverageDetails,
  },
};
